import type { JSX } from 'solid-js';
import styles from './page-header.module.css';

export const PageHeader = (props: {
  eyebrow?: string;
  title: string;
  description: string;
  actions?: JSX.Element;
  density?: 'editorial' | 'compact';
}) => (
  <header class={`${styles.header} ${props.density === 'compact' ? styles.compact : ''}`.trim()}>
    <div>
      {props.eyebrow && <p class={styles.eyebrow}>{props.eyebrow}</p>}
      <h1>{props.title}</h1>
      <p class={styles.description}>{props.description}</p>
    </div>
    {props.actions && <div class={styles.actions}>{props.actions}</div>}
  </header>
);
